import { render, staticRenderFns } from "./pageheader.vue?vue&type=template&id=8914cdea&scoped=true&"
import script from "./pageheader.vue?vue&type=script&lang=js&"
export * from "./pageheader.vue?vue&type=script&lang=js&"
import style0 from "./pageheader.vue?vue&type=style&index=0&id=8914cdea&lang=less&scoped=true&"
import style1 from "./pageheader.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8914cdea",
  null
  
)

export default component.exports